var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useTheme } from '@corti/theme';
import { Base } from 'lib/cortiUI';
export function ViewContentCard(props) {
    const { children } = props, rest = __rest(props, ["children"]);
    const theme = useTheme();
    return (React.createElement(Base, Object.assign({ display: "grid", borderRadius: 12, gap: 6, p: 8, background: theme.palette.background.card, boxShadow: theme.shadows[2], minWidth: 360, width: '100%', maxWidth: 600, gridTemplateColumns: 'minmax(0px, 1fr)' }, rest), children));
}
